// extracted by mini-css-extract-plugin
export default {"history":"AboutUs_history__BE--M","wrapper":"AboutUs_wrapper__J+l+y","img":"AboutUs_img__rYENa","today":"AboutUs_today__LaDQ8"};